import { SESSION_ROOM_COLORS } from './colors';

export const theme = {
  colors: SESSION_ROOM_COLORS,
};
